import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';
import Footer from '../components/Footer';
import Simulator from '../components/simulator/Simulator';

const SimulatorHeader = () => {
  const { t } = useTranslation();
  return (
    <header className="bg-gray-900 text-white py-4 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-3">
          <img src="/img/brand/isotipo-web.png" alt="" className="h-10" />
          <img src="/img/brand/logotipo-web.png" alt="Tenku" className="h-6" />
        </Link>
        <nav className="flex space-x-8 items-center">
          <Link to="/" className="hidden md:block text-gray-300 hover:text-brand transition-colors">
            {t('header.backToTenku')}
          </Link>
          <LanguageSelector />
        </nav>
      </div>
    </header>
  );
};

const FixtureSimulator = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('sim.docTitle');
    return () => {
      document.title = 'Tenku';
    };
  }, [t]);

  return (
    <div className="bg-gray-900 min-h-screen">
      <SimulatorHeader />
      <main className="px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t('sim.title')}</h1>
            <p className="text-lg text-gray-300">{t('sim.subtitle')}</p>
          </div>
          <Simulator />
          <section className="mt-16 text-center bg-gray-800 rounded-2xl py-12 px-6">
            <h2 className="text-3xl font-bold text-white mb-4">{t('sim.ctaTitle')}</h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8">{t('sim.ctaSubtitle')}</p>
            <Link
              to="/open"
              className="inline-flex items-center bg-brand hover:bg-brand-dark text-white font-semibold px-8 py-4 rounded-xl transition-colors"
            >
              {t('sim.ctaButton')}
            </Link>
            <p className="text-sm text-gray-400 mt-4">{t('sim.ctaStores')}</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FixtureSimulator;
